import { defineSemanticTokens, defineTokens } from '@pandacss/dev'

const tokens = defineTokens.colors({
  light: {
    '1': { value: '#fefcff' },
    '2': { value: '#fdf7fd' },
    '3': { value: '#fbebfb' },
    '4': { value: '#f7def8' },
    '5': { value: '#f2d1f3' },
    '6': { value: '#e9c2ec' },
    '7': { value: '#deade3' },
    '8': { value: '#cf91d8' },
    '9': { value: '#ab4aba' },
    '10': { value: '#a144af' },
    '11': { value: '#953ea3' },
    '12': { value: '#53195d' },
    a1: { value: '#aa00ff03' },
    a2: { value: '#c000c008' },
    a3: { value: '#cc00cc14' },
    a4: { value: '#c200c921' },
    a5: { value: '#b700bd2e' },
    a6: { value: '#a400b03d' },
    a7: { value: '#9900a852' },
    a8: { value: '#9000a56e' },
    a9: { value: '#89009eb5' },
    a10: { value: '#7f0092bb' },
    a11: { value: '#730086c1' },
    a12: { value: '#40004be6' },
  },
  dark: {
    '1': { value: '#181118' },
    '2': { value: '#201320' },
    '3': { value: '#351a35' },
    '4': { value: '#451d47' },
    '5': { value: '#512454' },
    '6': { value: '#5e3061' },
    '7': { value: '#734079' },
    '8': { value: '#92549c' },
    '9': { value: '#ab4aba' },
    '10': { value: '#b658c4' },
    '11': { value: '#e796f3' },
    '12': { value: '#f4d4f4' },
    a1: { value: '#f112f108' },
    a2: { value: '#f22ff211' },
    a3: { value: '#fd4cfd27' },
    a4: { value: '#f646ff3a' },
    a5: { value: '#f455ff48' },
    a6: { value: '#f66dff56' },
    a7: { value: '#f07cfd70' },
    a8: { value: '#ee84ff95' },
    a9: { value: '#e961feb6' },
    a10: { value: '#ed70ffc0' },
    a11: { value: '#f19cfef3' },
    a12: { value: '#feddfef4' },
  },
})
const semanticTokens = defineSemanticTokens.colors({
  '1': { value: { _light: '{colors.plum.light.1}', _dark: '{colors.plum.dark.1}' } },
  '2': { value: { _light: '{colors.plum.light.2}', _dark: '{colors.plum.dark.2}' } },
  '3': { value: { _light: '{colors.plum.light.3}', _dark: '{colors.plum.dark.3}' } },
  '4': { value: { _light: '{colors.plum.light.4}', _dark: '{colors.plum.dark.4}' } },
  '5': { value: { _light: '{colors.plum.light.5}', _dark: '{colors.plum.dark.5}' } },
  '6': { value: { _light: '{colors.plum.light.6}', _dark: '{colors.plum.dark.6}' } },
  '7': { value: { _light: '{colors.plum.light.7}', _dark: '{colors.plum.dark.7}' } },
  '8': { value: { _light: '{colors.plum.light.8}', _dark: '{colors.plum.dark.8}' } },
  '9': { value: { _light: '{colors.plum.light.9}', _dark: '{colors.plum.dark.9}' } },
  '10': { value: { _light: '{colors.plum.light.10}', _dark: '{colors.plum.dark.10}' } },
  '11': { value: { _light: '{colors.plum.light.11}', _dark: '{colors.plum.dark.11}' } },
  '12': { value: { _light: '{colors.plum.light.12}', _dark: '{colors.plum.dark.12}' } },
  a1: { value: { _light: '{colors.plum.light.a1}', _dark: '{colors.plum.dark.a1}' } },
  a2: { value: { _light: '{colors.plum.light.a2}', _dark: '{colors.plum.dark.a2}' } },
  a3: { value: { _light: '{colors.plum.light.a3}', _dark: '{colors.plum.dark.a3}' } },
  a4: { value: { _light: '{colors.plum.light.a4}', _dark: '{colors.plum.dark.a4}' } },
  a5: { value: { _light: '{colors.plum.light.a5}', _dark: '{colors.plum.dark.a5}' } },
  a6: { value: { _light: '{colors.plum.light.a6}', _dark: '{colors.plum.dark.a6}' } },
  a7: { value: { _light: '{colors.plum.light.a7}', _dark: '{colors.plum.dark.a7}' } },
  a8: { value: { _light: '{colors.plum.light.a8}', _dark: '{colors.plum.dark.a8}' } },
  a9: { value: { _light: '{colors.plum.light.a9}', _dark: '{colors.plum.dark.a9}' } },
  a10: { value: { _light: '{colors.plum.light.a10}', _dark: '{colors.plum.dark.a10}' } },
  a11: { value: { _light: '{colors.plum.light.a11}', _dark: '{colors.plum.dark.a11}' } },
  a12: { value: { _light: '{colors.plum.light.a12}', _dark: '{colors.plum.dark.a12}' } },
  default: { value: { _light: '{colors.plum.light.9}', _dark: '{colors.plum.dark.9}' } },
  emphasized: { value: { _light: '{colors.plum.light.10}', _dark: '{colors.plum.dark.10}' } },
  fg: { value: { _light: 'white', _dark: 'white' } },
  text: { value: { _light: '{colors.plum.light.a11}', _dark: '{colors.plum.dark.a11}' } },
})

export default {
  name: 'plum',
  tokens,
  semanticTokens,
}
